import React from 'react'
import BaseIcon from './BaseIcon'

const UpIcon = (props: any) => {
  return <BaseIcon img="/img/ic-arrow-actions.png" onClick={props.onClick} />
}

export default UpIcon
